import React from 'react'
import { func, bool, string, element } from 'prop-types'
import { Button, Form } from '@cobalt/cobalt-react-components'

class NoRecaptchaSecureForm extends React.Component {
  render() {
    const {
      children,
      submitLabel,
      disabledForm,
      onSubmit,
      isFormValid,
      isDanger
    } = this.props
    const isSubmitDisabled = disabledForm || !isFormValid
    return (
      <Form>
        {children}
        <Form.Field>
          {isDanger ? (
            <Button
              type={Button.SUBMIT_TYPE}
              state={disabledForm ? Button.LOADING_STATE : null}
              disabled={isSubmitDisabled}
              onClick={onSubmit}
              danger
              fullWidth
            >
              {submitLabel}
            </Button>
          ) : (
            <Button
              type={Button.SUBMIT_TYPE}
              state={disabledForm ? Button.LOADING_STATE : null}
              disabled={isSubmitDisabled}
              onClick={onSubmit}
              primary
              fullWidth
            >
              {submitLabel}
            </Button>
          )}
        </Form.Field>
      </Form>
    )
  }
}

NoRecaptchaSecureForm.propTypes = {
  onSubmit: func.isRequired,
  isFormValid: bool.isRequired,
  disabledForm: bool.isRequired,
  submitLabel: string.isRequired,
  isDanger: bool,
  children: element.isRequired
}

NoRecaptchaSecureForm.defaultProps = {
  isDanger: false
}

export default NoRecaptchaSecureForm
